import { t } from "@lingui/macro";
import { spaData } from "../Modals/spaData";

export const getFacilityData = () => [
  {
    image: "../assets/images/rooms/SeniorSuite.webp",
    title: t`Rooms`,
    description: t`Discover our wide variety of rooms, suited for your maximum comfort and unforgettable experience.`,
    buttonText: t`Check available rooms`,
    link: "/book-room",
  },
  {
    image: "../assets/images/attractions/SPA.webp",
    title: "SPA", // nazwa własna, nie tłumaczymy
    description: t`Discover serenity at Balneario El Arenal, where luxury and nature come together to offer you an unparalleled wellness experience.`,
    buttonText: t`Massage selection`,
    reverse: true,
    isModal: true,
    modalData: { spaData },
  },
  {
    image: "../assets/images/attractions/Pool.webp",
    title: t`Our pools`,
    description: t`Relax in one of our hydro massage baths, float carelessly in our family pools or let your young ones’ imagination run free in our pirates and dragons thematic pool.`,
    buttonText: t`Buy a ticket`,
    link: "/buy-tickets",
  },
  {
    image: "../assets/images/attractions/Camping.png",
    title: t`Camping`,
    description: t`Late evening campfires, the breeze of fresh air in the morning and the singing of birds. Living close to nature has never been more relaxing thanks to our camping experience.`,
    buttonText: t`Buy a ticket`,
    link: "/book-room",
    reverse: true,
  },
  {
    image: "../assets/images/attractions/Food.webp",
    title: t`Restaurant`,
    description: t`Grab yourself a snack and a cold drink at our resort’s restaurant.`,
    buttonText: t`See the menu`,
    link: "/book-room",
  },
];
